export interface FaqItem {
  question: string
  answer: string
  category?: string
}

export interface FaqCategory {
  name: string
  items: FaqItem[]
}

export const faqData: FaqItem[] = [
  {
    question: "Wie alt muss man sein, um an den Rennen teilnehmen zu können?",
    answer:
      "Wir haben kein Mindestalter, bei uns zählt ausschließlich deine Größe. Bist du oder dein Kind unter 130 cm groß, bieten sich unsere Rimo Sinus Nano Karts an. Diese betreiben wir im Untergeschoss auf einer eigenen kleinen Strecke speziell für unsere kleinsten Gäste. Ab 130cm Körpergröße kannst du bei uns mit den Rimo Sinus Mini fahren. Für diese Fahrzeuge haben wir im Untergeschoss eine eigene Strecke. Ab 155cm könnt ihr auf unserer Strecke im Obergeschoss fahren mit den Rimo Sius Ion.",
    category: "Allgemein",
  },
  {
    question: "Ist eine Reservierung erforderlich, um auf der Kartbahn zu fahren?",
    answer:
      "Eine Reservierung ist nicht zwingend erforderlich, wird von uns aber empfohlen, damit ihr euch nicht umsonst den ganzen weiten Weg zu uns aufgemacht habt. Aufgrund einer recht hohen Auslastung können wir euch bei einem spontanen Besuch, gerade an Wochenenden, nicht garantieren, dass wir euch einen Slot anbieten können.",
    category: "Buchung & Reservierung",
  },
  {
    question: "Welche Kleidung und welche Sicherheitsausrüstung ist für das Kartfahren erforderlich?",
    answer:
      "Wir empfehlen euch sportliche Kleidung. Aufgrund der Helmhygiene ist eine Sturmhaube erforderlich. Solltet ihr keine haben, wird euch von uns eine gegen eine kleine Gebühr zur Verfügung gestellt. Ein Helm ist bei der Fahrt vorgeschrieben.",
    category: "Sicherheit & Ausrüstung",
  },
  {
    question: "Sind eigene Helme erlaubt oder werden Helme gestellt?",
    answer: "Eigene Helme, sofern sie den Anforderungen entsprechen sind erlaubt.",
    category: "Sicherheit & Ausrüstung",
  },
  {
    question: "Gibt es Spezialtarife für Gruppen oder Veranstaltungen?",
    answer:
      "Wir haben spezielle Angebote für geschlossene Veranstaltungen und Geburstage. Lasse dich hierfür gerne von uns beraten.",
    category: "Buchung & Reservierung",
  },
  {
    question: "Wie lange dauert eine typische Rennsession?",
    answer:
      "Die Dauer eines Rennens hängt von der Bahn ab, auf welcher ihr fahrt. Ein Rennen auf unserer kleinen Bahn im Erdgeschoss geht 10 Minuten. Ein Rennen auf unserer großen Bahn im Obergeschoss geht ca 15 Minuten. Bei geschlossenen Veranstaltungen oder privaten Events können diese Werte durch das Anbieten von Qualifying abweichen.",
    category: "Allgemein",
  },
  {
    question: "Gibt es Voraussetzungen bezüglich des Führerscheins oder anderer Genehmigungen?",
    answer:
      "Nein, zum Kartfahren benötigst du keinen Führerschein oder andere Nachweise oder Zertifikate. Lediglich für unseren Expertenmodus brauchst du eine Lizenz, welche dir von uns ausgestellt wird.",
    category: "Allgemein",
  },
  {
    question: "Kann man private Veranstaltungen oder Geburtstagsfeiern auf der Kartbahn organisieren?",
    answer:
      "Ja ihr könnt gerne euren Geburstag, ein Firmenevent oder eine andere private Feuer bei uns feiern. Wir bieten euch nach dem Rennen auch in unserem Bistro die Möglichkeit bei Speisen und Getränken den Tag ausklingen zu lassen.",
    category: "Buchung & Reservierung",
  },
]

// Kategorisierte FAQs für zukünftige Erweiterungen
export const faqCategories: FaqCategory[] = [
  {
    name: "Allgemein",
    items: faqData.filter((item) => item.category === "Allgemein"),
  },
  {
    name: "Buchung & Reservierung",
    items: faqData.filter((item) => item.category === "Buchung & Reservierung"),
  },
  {
    name: "Sicherheit & Ausrüstung",
    items: faqData.filter((item) => item.category === "Sicherheit & Ausrüstung"),
  },
]
